import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UserRoleResponse } from '../../../types/UserRole';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

type UseGetAllUserRoleParams = {
  page?: number;
  per_page?: number;
  search?: string;
  filters?: {
    employee?: string;
  };
};

export type UseGetAllUserRoleProps = {
  params?: UseGetAllUserRoleParams;
  enabled?: boolean;
};

export const fetchAllUserRoles = async ({ params }: UseGetAllUserRoleProps) => {
  const response = await CustomAxios.get<UserRoleResponse>(`user_roles`, { params });
  const { data } = response;
  return data;
};

export function useGetAllUserRoles({ params, enabled = true }: UseGetAllUserRoleProps) {
  const queryKey: any = [queryKeys.allUserRoles, params];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: () => fetchAllUserRoles({ params }),
    placeholderData: keepPreviousData,
  });
  return query;
}
